import { QueryFactory, VisitTypeDto } from '@lmt/shared-types';
import i18next from 'i18next';

export function useActiveVisitTypes(selectedValue?: number | null) {
  const dictionary = useVisitTypeDictionary();
  return (
    QueryFactory.VisitTypeQuery.useGetQuery({
      select: (data: VisitTypeDto[]) =>
        (data ?? [])
          ?.filter((x) => !x.isDeleted || x.id === selectedValue)
          .sort((a, b) =>
            dictionary?.manualOrdering
              ? a?.manualOrderPosition - b?.manualOrderPosition
              : i18next
                  .t(a.value as any)
                  .localeCompare(i18next.t(b.value as any)),
          ),
    }).data ?? []
  );
}

export function useVisitTypes() {
  return QueryFactory.VisitTypeQuery.useGetQuery().data ?? [];
}

export function useVisitTypeDictionary() {
  const dictionariesQuery = QueryFactory.DataBlockDictionaryQuery.useGetQuery();
  return dictionariesQuery.data?.find(
    (x) => x.title === 'Visit Types' && x.isExternal === true,
  );
}
